import { useContext, useEffect, useState } from "react";
import { 
    Grid, TextField
} from '@mui/material';

function Perfil(){
    const [usuario, setUsuario] = useState({
        nome: '',
        email: '',
        tipo: '',
    });

    const getAuth = ()=>{
        const data = localStorage.getItem('userAuth');

        if(data != null){
            let user = JSON.parse(data);
            setUsuario({
                nome: user.nome,
                email: user.email,
                tipo: (user.tipo === 'V') ? 'Vendedor' : 'Administrador',
            });
        }
    };

    useEffect(()=>{
        setTimeout(() => {
            getAuth();
        }, 1000);
    }, []);

    return (
        <Grid container rowSpacing={2} columnSpacing={2}>
            <Grid size={{ xs: 12, md: 12 }}>
                <TextField
                    id="nmUser" 
                    type="text"
                    label="Usuário" 
                    variant="outlined"
                    size="small"
                    fullWidth 
                    value={usuario.nome}
                    sx={{ backgroundColor: '#fff' }}
                    InputLabelProps={{ shrink: true }}
                    readonly
                />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
                <TextField
                    id="emailUser" 
                    type="text"
                    label="Login de acesso" 
                    variant="outlined"
                    size="small"
                    fullWidth 
                    value={usuario.email}
                    sx={{ backgroundColor: '#fff' }}
                    InputLabelProps={{ shrink: true }}
                    readonly
                />
            </Grid>
              <Grid size={{ xs: 12, md: 12 }}>
                <TextField
                    id="tpUser" 
                    type="text"
                    label="Função" 
                    variant="outlined"
                    size="small"
                    fullWidth 
                    value={usuario.tipo}
                    sx={{ backgroundColor: '#fff' }}
                    InputLabelProps={{ shrink: true }}
                    readonly
                />
            </Grid>
        </Grid>
    );
}

export default Perfil;